module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workOrder"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "order_detail-title"
  }, [_vm._v("角色申请详情")]), _vm._v(" "), _c('div', {
    staticClass: "order_detail-role"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.showInfo,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请角色"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.showInfo.roleType),
      callback: function($$v) {
        _vm.$set(_vm.showInfo, "roleType", $$v)
      },
      expression: "showInfo.roleType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请时间"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.showInfo.requestTime),
      callback: function($$v) {
        _vm.$set(_vm.showInfo, "requestTime", $$v)
      },
      expression: "showInfo.requestTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "orderInput",
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true",
      "type": "textarea",
      "rows": 6
    },
    model: {
      value: (_vm.showInfo.requestRemark),
      callback: function($$v) {
        _vm.$set(_vm.showInfo, "requestRemark", $$v)
      },
      expression: "showInfo.requestRemark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批状态"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.stateMap[_vm.showInfo.status]),
      callback: function($$v) {
        _vm.$set(_vm.stateMap, _vm.showInfo.status, $$v)
      },
      expression: "stateMap[showInfo.status]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批时间"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.showInfo.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.showInfo, "approvalTime", $$v)
      },
      expression: "showInfo.approvalTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "orderInput",
    attrs: {
      "label": "审批意见"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true",
      "type": "textarea",
      "rows": 6
    },
    model: {
      value: (_vm.showInfo.approvalRemark),
      callback: function($$v) {
        _vm.$set(_vm.showInfo, "approvalRemark", $$v)
      },
      expression: "showInfo.approvalRemark"
    }
  })], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5a293f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/roleApplyDetails.vue
// module id = 1005
// module chunks = 1